import { EditionReleaseSelect } from './edition-release-select.js';

const STUDENT_CONFIRMED_EVENT = 'mhecomm-he-student-confirmed';
const SIGN_IN_URL_SELECTOR = '#hePdpEvergreenSignInUrl';

function updateSignInUrl() {
  const redirect = new URL(window.location.href);
  ['viewOption', 'edition', 'release', 'cid'].forEach((key) => redirect.searchParams.delete(key));
  document.querySelectorAll(`${SIGN_IN_URL_SELECTOR}, a[data-automation-id="modalSigninUrl"]`).forEach((link) => {
    const url = new URL(link.href);
    url.searchParams.set('redirectUrl', redirect.toString());
    link.href = url.toString();
  });
}

function openFirstVisibleAccordion(accordion) {
  if (!accordion || accordion.querySelector('.accordion-item:not(.d-none) .accordion-collapse.show')) return;
  const item = accordion.querySelector('.accordion-item:not(.d-none)');
  item?.querySelector('.accordion-button')?.classList.remove('collapsed');
  item?.querySelector('.accordion-button')?.setAttribute('aria-expanded', 'true');
  item?.querySelector('.accordion-collapse')?.classList.add('show');
}

function toggleReleaseNotes(show) {
  document.querySelectorAll('.accordion-item[data-accordion-type="release_notes"]').forEach((item) => {
    if (!show) {
      item.querySelector('.accordion-button')?.classList.add('collapsed');
      item.querySelector('.accordion-button')?.setAttribute('aria-expanded', 'false');
      item.querySelector('.accordion-collapse')?.classList.remove('show');
    }
    item.classList.toggle('d-none', !show);
    if (!show) openFirstVisibleAccordion(item.closest('.accordion'));
  });
}

export function initializeEvergreenPdp(root = document) {
  if (!root.body?.classList.contains('mhecomm-he-pdp-page')) return;

  const editionSelectors = Array.from(
    root.querySelectorAll('.editionReleaseSelect'),
    (element) => new EditionReleaseSelect(element)
  );
  const toggleGroups = root.querySelectorAll('.studentInstructorToggleGroup');
  let currentView;
  let studentCorrectionApplied = false;

  const updateView = (view) => {
    currentView = view;
    editionSelectors.forEach((selector) => selector.setView(view));
    updateSignInUrl();
    root.querySelector('#hePDPInstructorSection')?.classList.toggle('d-none', view !== 'instructor');
    toggleReleaseNotes(view === 'instructor');
  };

  document.addEventListener(STUDENT_CONFIRMED_EVENT, () => {
    if (studentCorrectionApplied) return;
    studentCorrectionApplied = true;
    if (currentView !== 'student') {
      document.dispatchEvent(new CustomEvent('studentInstructorToggleGroupChange', { detail: { value: 'student' } }));
    }
  });

  const viewOption = new URLSearchParams(window.location.search).get('viewOption');
  const view = viewOption || (editionSelectors[0]?.isUpcomingSelected ? 'instructor' : 'student');
  updateView(view);
  toggleGroups.forEach((group) => group.querySelector(`[id^="${view}"]`)?.click());

  document.addEventListener('studentInstructorToggleGroupChange', (event) => updateView(event.detail?.value));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeEvergreenPdp(), { once: true });
} else {
  initializeEvergreenPdp();
}
